import {
  FleetVehicleFireExtinguisherEditFormValues,
  FleetVehicleFireExtinguisherSearchFormValues,
} from "./types";

export const initialFleetVehicleFireExtinguisherSearchForm: FleetVehicleFireExtinguisherSearchFormValues =
  {
    search: "",
  };

export const initialFleetVehicleFireExtinguisherEditForm: FleetVehicleFireExtinguisherEditFormValues =
  {
    name: "",
    price: null,
    weight: null,
    expirationDate: null,
    serialNumber: null,
  };
